import jstz from 'jstz';
import moment from 'moment-timezone';

const lightbox = require('lightbox2');

(function () {

  'use strict';

  var SELLER_ANNOUNCEMENT_TITLE_ABSENT = 1;
  var ADESA_ANNOUNCEMENT_RAW = 33;
  var SELLER_PURCHASE_RECEIPT_INFO = 34;
  var AS_IS_ID = "1";
  var STANDARD = "2";
  var FRONT_LINE_READY_ID = "4";
  var CERTIFIED_ID = "5";
  var AS_DESCRIBED_ID = "6";
  var WHOLESALE_READY_ID = "7";
  var AS_IS_PLUS_ID = "9";
  var NIADA_CERTIFIED_ID = "10";
  var ENHANCED_ID = "11";
  var elevateZoomOption = {
    zoomType: "lens",
    containLensZoom: true,
    cursor: 'pointer',
    responsive: 'true',
    gallery:'thumbnails',
    galleryActiveClass: "active"
  };

  angular
    .module('app.vehicledetails')
    .controller('VehicleDetailsController', [
      '$scope',
      'OpenlaneService',
      '$routeParams',
      'CommonUtil',
      'VehicleDetailService',
      '$timeout',
      '$document',
      'DataService',
      '$location',
      'GaService',
      '$window',
      '$anchorScroll',
      'CacheSearchParams',
      'SearchService',
      'VidDetailsService',
      VehicleDetailsController
    ]);

  function VehicleDetailsController($scope, openlaneService, $routeParams, util, vdService, $timeout, $document, dataService, $location, gaService, $window, $anchorScroll,
                                    CacheSearchParams, searchService, vidDetailsService) {
    var vm = this;
    init();

    function init() {
      $anchorScroll.yOffset = 120;
      var tUrl = $location.path().toString();
      var vUrl = tUrl.substring(0, tUrl.lastIndexOf("/"));
      gaService.gaTrackPageViewAsync(vUrl, 'Vehicle Details Page');
      openlaneService.initUserInfoContext().then(function (userContext) {
        var conversationId = userContext.conversationId;
        var orgId = userContext.Organizations[0].id;
        var vehicleId = $routeParams.vehicleId;
        var language = $routeParams.langCode;
        $scope.getLanguageCode = getLanguageCode;

        Promise.all([
          vdService.getVehicleDetail(vehicleId, orgId, conversationId, language).then(consumeVehicleDetail),
          vdService.getCentralizedAnnouncement(vehicleId, conversationId, language).then(consumeCentralizedAnnouncements),
          vdService.getWindowSticker(vehicleId, conversationId, language).then(consumeWindowSticker),
          vdService.getAdditionalVehicleInfo(vehicleId, conversationId, language).then(consumeAdditionalVehicleInfo),
          vdService.getVehicleDisclosure(vehicleId, conversationId).then(consumeVehicleDisclosure),
          vdService.getVdpProviders(vehicleId, conversationId).then(consumeVdpProviders),
          vdService.getEquipment(vehicleId, conversationId).then(consumeEquipment),
          vdService.getConditionDetail(vehicleId, conversationId, language).then(consumeConditionDetail),
          vdService.getVehicleDamages(vehicleId, conversationId, language).then(consumeVehicleDamages),
          vdService.getTireCondition(vehicleId, conversationId).then(consumeTireConditions),
          vdService.getStatements(vehicleId, conversationId).then(consumeStatements),
        ]).then(() => $scope.$digest());

        scroll_up_button_enable();
      });

      angular.element($window).bind('resize', function (){
        $timeout(equalSideDivs, 200);
        if (!isMobile.any()) {
          angular.element('.zoomContainer').remove();
          angular.element("#mainPicture").elevateZoom(elevateZoomOption);
        }
      });
    }

    function consumeVehicleDetail(response) {
      var vehicleDetail = response.data;

      if (replaceLocationName && replaceLocationName.length > 0) {
        replaceLocationName.forEach(l => {
          if (l.nfrom && l.nto) {
              if (vehicleDetail.processLocation && vehicleDetail.processLocation.toUpperCase().indexOf(l.nfrom.toUpperCase()) >= 0) {
                  vehicleDetail.processLocation = l.nto;
              }
          }
        })
      }

        $scope.vehicleDetailResponse = vehicleDetail;

      var liveBlockChannel = undefined;
      var runListChannel = undefined;
      var auctionChannel = undefined;


      if (angular.isDefined(response.data.auctionChannelsInfo.liveBlockInfo)) {
        liveBlockChannel = response.data.auctionChannelsInfo.liveBlockInfo;
        auctionChannel = liveBlockChannel;
      }
      if (angular.isDefined(response.data.auctionChannelsInfo.runListInfo)) {
        runListChannel = response.data.auctionChannelsInfo.runListInfo;
        if (!angular.isDefined(liveBlockChannel))
          auctionChannel = runListChannel;
      }

      if (angular.isDefined(response.data.auctionChannelsInfo.purchaseInfo)){
        $scope.imageService = handleHighResImageService(response.data.auctionChannelsInfo.purchaseInfo);
      } else {
        $scope.imageService = undefined;
      }

      if (angular.isDefined(liveBlockChannel) && angular.isDefined(runListChannel)) {
        auctionChannel.titleHeader = dataService.getCurrentTranslation()['vdp.auction.channel.runlist.liveblock.title'];
      } else if (angular.isDefined(liveBlockChannel) || angular.isDefined(runListChannel)) {
        auctionChannel.titleHeader = dataService.getCurrentTranslation()['vdp.auction.channel.runlist.title'];
      }

      if(auctionChannel) {
        auctionChannel.conditionTypeText = getConditionTypeText(liveBlockChannel, runListChannel);
      }

      if ( angular.isDefined(liveBlockChannel)) {
        try{
        var new_date = moment(liveBlockChannel.auctionDate);
        var startDate = new_date.locale('en').tz(getUserTimeZone()).format("MMM Do, YYYY");
        var startTime = new_date.locale('en').tz(getUserTimeZone()).format("h:mm A zz");

        auctionChannel.startDate = startDate;
        auctionChannel.startTime = startTime;
        }catch(e){
          console.log(e);
        }

      }

      if ( angular.isDefined(runListChannel) && angular.isUndefined(liveBlockChannel)) {
        var auctionDateObj = new Date(runListChannel.auctionDate);
        var theYear = auctionDateObj.getFullYear();
        var theMonth = auctionDateObj.getMonth() + 1;
        var theDay = auctionDateObj.getDate();

        auctionChannel.formattedAuctionDate = theMonth + "/" + theDay + "/" + theYear;
      }

      if (auctionChannel !== undefined) {

        isEmptyString(auctionChannel.eventGroupName) ? auctionChannel.liveBlockEventType = '' : auctionChannel.liveBlockEventType = auctionChannel.eventGroupName;
        isEmptyString(auctionChannel.consignorGroup) ? auctionChannel.consignorGroup = '' : auctionChannel.consignorGroup = auctionChannel.consignorGroup;

        var laneRun = auctionChannel.laneNumber || auctionChannel.lotNumber;
        laneRun += ' - ' + auctionChannel.runNumber;
        auctionChannel.laneRunNumber = laneRun;
        // auctionChannel.runNumber = auctionChannel.runNumber;
      }

      $scope.auctionChannel = auctionChannel;
      $scope.oemData = splitIntoColumns(vehicleDetail.oemData, 3);

      var mainPictureIndex = 0;
      var pictures = vehicleDetail.pictures;
      for (var i = 0; i < pictures.length; i++) {
        if (pictures[i].primary === 1) {
          mainPictureIndex = i;
        }
      }

      $scope.mainPictureIndex = mainPictureIndex;
      if (vehicleDetail.pictures.length == 0) {
        $scope.vdpPrimaryPicture = {};
        $scope.vdpPrimaryPicture['filePath'] = 'resource/image/common/Image_Holder_' + $routeParams.langCode + '.png';
      } else {
        $scope.vdpPrimaryPicture = vehicleDetail.pictures[mainPictureIndex];
      }
      $scope.printPreviewImgs = vehicleDetail.pictures;
      $scope.vehicleDetailResponse.mileage = Number(vehicleDetail.mileage);

      $scope.$watch('vehicleDetailResponse', function () {
        angular.element("#thumbnails").owlCarousel({
          items: 3,
          itemsDesktopSmall: [979, 3],
          itemsTablet: [768, 3],
          itemsMobile: [479, 3],
          responsive: true,
          pagination: true,
          navigation: true,
          scrollPerPage: true,
          navigationText: ["<img src='resource/image/common/prev.png' class='NavArrows'/>", "<img src='resource/image/common/next.png' class='NavArrows'/>"],
          responsiveRefreshRate: 100
        });
        if (!isMobile.any()) {
          // TODO: Remove lightbox and reimplement this

          if(lightbox && !document.getElementById('lightbox')) {
            try {
              const vdpLightbox = lightbox.init();
              vdpLightbox.option({
                albumLabel: dataService.getCurrentTranslation()['vdp.lightbox.caption'],
                positionFromTop: 100
              });
            } catch (e) {
              console.log(e);
            }
          }

        }

      });

      $scope.$watch('vdpPrimaryPicture', function (){
        if (!isMobile.any()) {
          angular.element("#mainPicture").elevateZoom(elevateZoomOption);
          $timeout(function(){
            var zoomBoxes = angular.element("body").find(".zoomContainer");
            if(zoomBoxes.length > 1) {
              zoomBoxes[zoomBoxes.length - 1].remove();
            }
          }, 100);
        }

      });

      $timeout(equalSideDivs, 1200);
    }

    function consumeCentralizedAnnouncements(response) {
      $scope.centralizedAnnouncementResponse = {};
      var announcements = response.data.centralizedAnnouncements;
      if (announcements.length === 0) return;
      var i;

      for (i = 0; i < announcements.length; i++) {
        processAnnouncement(announcements[i]);
      }

      function processAnnouncement(announcement) {
        var type = announcement.type;
        var sectionNumber = announcement.sectionNumber;
        var sectionText = announcement.sectionText;

        if (isEmptyString(type) || isEmptyString(sectionNumber) || isEmptyString(sectionText)) return;

        if (sectionNumber == SELLER_ANNOUNCEMENT_TITLE_ABSENT) {
          $scope.centralizedAnnouncementResponse.titleAbsent = sectionText
        }
        else if (sectionNumber == ADESA_ANNOUNCEMENT_RAW) {
          $scope.centralizedAnnouncementResponse.centralAnnouncement = breakingLongStringIntoList(sectionText);
        }
        else if (sectionNumber != SELLER_PURCHASE_RECEIPT_INFO) {
          $scope.centralizedAnnouncementResponse.generalAnnouncement = sectionText;
        }

      }


    }

    function consumeVdpProviders(response) {
      var data = response.data;
      $scope.vdpProviderResponse = data;

    }

    function consumeAdditionalVehicleInfo(response) {
      var additionalInfo = response.data.additionalVehicleInfo;
      $scope.additionalVehicleInfoResponse = '';
      if (isEmptyString(additionalInfo[0])) {
        $scope.additionalVehicleInfoResponse = '';
      } else {
        for (var i = 0; i < additionalInfo.length; i++) {
          $scope.additionalVehicleInfoResponse += breakingLongStringIntoList(additionalInfo[i]);
        }

      }

    }

    function consumeVehicleDisclosure() {

    }

    function consumeWindowSticker(response) {
      var windowSticker = response.data;
      $scope.windowStickerResponse = undefined;
      if (!isEmptyString(windowSticker.windowStickerMessageURL)) {
        if (!$scope.printPage) {
          $scope.windowStickerResponse = windowSticker.windowStickerMessageURL;
        } else {
          $scope.windowStickerResponse = windowSticker.windowStickerMessageURL.replace(/<\/?a[^>]*>/g, "");
        }
      }
    }

    function consumeEquipment(response) {
      $scope.lowValueEquipmentResponse = splitIntoColumns(response.data.lowValueOptions, 3);
      $scope.highValueEquipmentResponse = splitIntoColumns(response.data.highValueOptions, 3)
    }

    function consumeConditionDetail(response) {
      var conditionDetail = response.data;
      $scope.conditionDetailResponse = conditionDetail;


      if (angular.isUndefined(conditionDetail.odors) || conditionDetail.odors.length == 0) {
        $scope.conditionDetailResponse.odors = dataService.getCurrentTranslation()['vdp.not.reported.label'];
      } else {
        $scope.conditionDetailResponse.odors = buildOdorText(conditionDetail);
      }

      if (angular.isDefined(conditionDetail.frameDamage) && !isEmptyString(conditionDetail.frameDamage)) {
        if (conditionDetail.frameDamage === "NO") {
          $scope.conditionDetailResponse.frameDamage = dataService.getCurrentTranslation()['no'];
        }

      }

      if (!isEmptyString(conditionDetail.smokedIn)) {
        if (conditionDetail.smokedIn === 'NO') {
          $scope.conditionDetailResponse.smokedIn = dataService.getCurrentTranslation()['no'];
        }
      }

      if (!isEmptyString(conditionDetail.paintWork)) {
        if (conditionDetail.paintWork === 'NO') {
          $scope.conditionDetailResponse.paintWork = dataService.getCurrentTranslation()['no'];
        }
      }

      if (angular.isUndefined(conditionDetail.keys) || conditionDetail.keys.length == 0) {
        $scope.conditionDetailResponse.keys = dataService.getCurrentTranslation()['vdp.not.reported.label'];
      } else {
        $scope.conditionDetailResponse.keys = buildKeyText(conditionDetail);
      }

      if (angular.isUndefined(conditionDetail.manuals) || conditionDetail.manuals.length == 0) {
        $scope.conditionDetailResponse.manuals = dataService.getCurrentTranslation()['vdp.not.reported.label'];
      } else {
        $scope.conditionDetailResponse.manuals = buildManualText(conditionDetail);
      }

      if (angular.isUndefined(conditionDetail.gradeLabel)) {
        $scope.conditionDetailResponse.gradeLabel = '';
      } else {
        if (conditionDetail.gradeLabel === 'AutoGrade') {
          $scope.conditionDetailResponse.gradeLabelTooltip = dataService.getCurrentTranslation()['vdp.autograde.tooltip'];
        } else {
          $scope.conditionDetailResponse.gradeLabelTooltip = dataService.getCurrentTranslation()['vdp.grade.tooltip'];
        }

      }

      $scope.$watch('conditionDetailResponse', function () {
        angular.element($document).foundation('equalizer', 'reflow');
      });

    }

    function consumeVehicleDamages(response) {
      if (!angular.isDefined(response.data)) return;

      $scope.damageResponse = response.data;
      $scope.damageOptionalHeaders = getDamagesColumnHeaders(response.data.regions);
      $scope.processedDamages = customizeDamage(response.data.regions, 6);
      function customizeDamage(damageObj, numberOfItems){

        if (!angular.isDefined(damageObj) || damageObj.length === 0) {
          return damageObj;
        }

        var i, k, start, end;
        var result = damageObj;
        for (i=0; i < damageObj.length; i++) {
          var damages = damageObj[i].damages;
          start = 0;
          k = 0;
          end = numberOfItems;
          result[i].customizedDamages = [];
          do {
            result[i].customizedDamages[k] = damages.slice(start, end);
            k++;
            start += numberOfItems;
            end += numberOfItems;
          } while (end < damages.length);
        }
        return result;
      }

      $timeout(function (){
        angular.element($document).foundation('equalizer', 'reflow');
        angular.element($document).foundation('reveal', {animation: 'fade'});
      }, 1200);
    }

    function consumeTireConditions(response) {
      if (!angular.isDefined(response.data)) return;

      $scope.tireConditionsResponse = response.data.tireConditions;
    }

    function consumeStatements(response) {
      if (!angular.isDefined(response.data)) return;

      $scope.statementResponse = response.data;
    }

    function getConditionTypeText(liveBlockChannel, runListChannel) {
      var conditionTypeId, conditionTypeName = "";

      if ((liveBlockChannel != null && liveBlockChannel.conditionTypeId != null)) {
        conditionTypeId = liveBlockChannel.conditionTypeId;
      }

      if (runListChannel != null && runListChannel.conditionTypeId != null) {
        conditionTypeId = runListChannel.conditionTypeId;
      }

      switch (conditionTypeId) {
        case AS_IS_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.asis"];
          break;
        case STANDARD:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.standard"];
          break;
        case FRONT_LINE_READY_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.frontlineready"];
          break;
        case CERTIFIED_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.certified"];
          break;
        case AS_DESCRIBED_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.asdescribed"];
          break;
        case WHOLESALE_READY_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.wholesaleready"];
          break;
        case AS_IS_PLUS_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.asisplus"];
          break;
        case NIADA_CERTIFIED_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.niada.certified"];
          break;
        case ENHANCED_ID:
          conditionTypeName = dataService.getCurrentTranslation()["vehicle.condition.enhanced"];
          break;
        default:
          conditionTypeId = -1;
          break;

      }

      if (conditionTypeId > 0) {
        return conditionTypeName;
      }
    }

    function getLanguageCode() {
      return $routeParams.langCode;
    }

    function openModal(modalId) {
      angular.element("#" + modalId).foundation('reveal', 'open');
    }

    function handleHighResImageService(purchaseContext) {
      var serviceTypes = purchaseContext.serviceTypes;
      var imageTier;
      var imageService = {};

      if (angular.isUndefined(serviceTypes)) {
        return null;
      }

      for (var i = 0; i < serviceTypes.length; i++) {
        if (serviceTypes[i].id == 7) {
          if (!angular.isUndefined(serviceTypes[i].services[0])) {
            imageTier = serviceTypes[i].services[0]["id"];
            if (imageTier == 26 || imageTier == 32 || imageTier == 33) {
              imageService.title = dataService.getCurrentTranslation()["vdp.optional.service.high.resolution.image.title"];
            } else if (imageTier == 30 || imageTier == 31) {
              imageService.title = dataService.getCurrentTranslation()["vdp.optional.service.standard.resolution.image.title"];
            }
            if (serviceTypes[i].services[0].details && serviceTypes[i].services[0].details.fee) {
              imageService.fee = serviceTypes[i].services[0].details.fee;
            }
            return imageService;
          }
        }
      }
      return null;

    }

    $scope.openGradeModal = function () {
      openModal("gradeModal");
    };

    $scope.openConditionTypeModal = function () {
      openModal("conditionTypeModal");
    };

    //back to search results
    $scope.backToSearchResults = function () {

      vidDetailsService.getNextAndPreviousVids('', 'leaveVdpFlag');

      $scope.lastSeacrhParams = CacheSearchParams.storeLastSearchParams();
      if ($scope.lastSeacrhParams.params) {
        $location.path($scope.getRootUrlNoFrontHash() + 'search-result').search($scope.lastSeacrhParams.params);
      } else {

        $location.path($scope.getRootUrlNoFrontHash() + 'search-result');
      }

    };

    $scope.changeToMain = function (index) {
      $scope.vdpPrimaryPicture = $scope.vehicleDetailResponse.pictures[index];
      $scope.mainPictureIndex = index;
    };

    $scope.triggerLightbox = function(index) {
      if (!isMobile.any()) {
        var group = document.getElementsByClassName('groupie');
        group[index].click();
      }

    };

    //scroll to hash tag
    $scope.scrollTo = function(hashTag) {
      $anchorScroll(hashTag);
    };

    $scope.validateOdors = function(odor) {
      return odor !== 'None' && odor !== 'Not Reported' && odor !== 'Non signalées';
    };

    // print preview page
    $scope.vehicleDetailsPrintPage = $location.absUrl() + '/print-preview';
    if ($location.$$path.indexOf('/print-preview') > -1) {
      $scope.printPage = true;
    } else {
      $scope.printPage = false;
    };

    // Next and Previous buttons function:
    // Array of VIDs from SRP current page

    $scope.lastVid = true;
    $scope.firstVid = true;
    $scope.$watch('vehicleDetailResponse', function(newData) {
      if (newData) {
        var currentVid = parseInt($scope.vehicleDetailResponse.vid);

        vidDetailsService.getNextAndPreviousVids(currentVid).then(
          function(res) {
            $scope.pathToNextVehicle = $location.$$absUrl.replace(currentVid, res.nextVid);
            $scope.pathToPreviusVehicle = $location.$$absUrl.replace(currentVid, res.previousVid);

            $scope.lastVid = (res.nextVid) ? false : true;
            $scope.firstVid = (res.previousVid) ? false : true;

            $timeout(function(){
              $scope.$digest();
            },0);

          },
          function(err) {
            console.log(err);
          }
        );

      }
    });

  }


  function getDamagesColumnHeaders(damageRegions) {
    var optionalColumnHeaders = {
      hasDamageImages: false,
      hasLaborTypeHours: false,
      hasPartCost: false,
      hasRepairEstimate: false,
      hasStatus: false
    };

    if (!damageRegions) return optionalColumnHeaders;


    var region;
    var damages;
    for (var i = 0; i < damageRegions.length; i++) {
      region = damageRegions[i];
      damages = region.damages;
      for (var k = 0; k < damages.length; k++) {
        if (!isEmptyString(damages[k].thumbNailPath)) {
          optionalColumnHeaders.hasDamageImages = true;
        }
        if (!isEmptyString(damages[k].laborType)) {
          optionalColumnHeaders.hasLaborTypeHours = true;
        }
        if (!isEmptyString(damages[k].partCost)) {
          optionalColumnHeaders.hasPartCost = true;
        }
        if (!isEmptyString(damages[k].showRepairEstimate) && (damages[k].showRepairEstimate == 'true')) {
          optionalColumnHeaders.hasRepairEstimate = true;
        }
        if (!isEmptyString(damages[k].status)) {
          optionalColumnHeaders.hasStatus = true;
        }
      }
    }

    return optionalColumnHeaders;
  }

  //split 1-dimension array into #num of array vertically
  function splitIntoColumns(array, numberOfColumns) {
    if (array === undefined || array.length === 0) return [];
    var i, k, j;
    var arrSize = array.length;
    var result = new Array(numberOfColumns);

    for (i=0; i<result.length; i++) {
      result[i] = [];
    }

    for (i=0, k=0, j=0; i < arrSize; i++) {
      result[k][j] = array[i];
      k++;
      if (k == numberOfColumns) {
        k = 0;
        j++;
      }
    }

    return result;
  }

  function buildOdorText(conditionDetail) {
    var sb = '';
    var i;
    for (i = 0; i < conditionDetail.odors.length; i++) {
      sb += conditionDetail.odors[i].name;
      if (conditionDetail.odors[i].name.length > 0 && conditionDetail.odors[i].type.length > 0) {
        sb += "-";
      }
      sb += conditionDetail.odors[i].type;
    }
    return sb;
  }

  function buildKeyText(conditionDetail) {
    var i, result;
    if (conditionDetail.keys.length != 0) {
      var x = [];
      for (i = 0; i < conditionDetail.keys.length; i++) {
        if (conditionDetail.keys[i].quantity < 0)
          x[i] = conditionDetail.keys[i].name;
        else
          x[i] = " " + conditionDetail.keys[i].name.charAt(0).toUpperCase() + conditionDetail.keys[i].name.slice(1) + "(" + conditionDetail.keys[i].quantity + ")";

      }
      result = x.join(",");
    }

    return result;
  }

  function buildManualText(conditionDetail) {
    var i, result = '';
    for (i = 0; i < conditionDetail.manuals.length; i++) {

      result += conditionDetail.manuals[i].name;

      if (conditionDetail.manuals[i].quantity.length > 0 && conditionDetail.manuals[i].quantity > 0) {
        result += "(";
        result += conditionDetail.manuals[i].quantity;
        result += ")";
      }
    }
    return result;
  }

  function breakingLongStringIntoList(longText) {
    var result = '', s;
    var temp = longText.split("\n");
    for (var i = 0; i < temp.length; i++) {
      s = temp[i].trim();
      if (isEmptyString(s)) continue;
      result += s + "<br />";
    }
    return result;
  }

  function getUserTimeZone() {
    var timezone = jstz.determine();
    return timezone.name();
  }

  function scroll_up_button_enable() {
    angular.element(document).ready(function () {

      angular.element("html,body").scrollTop(0);

      angular.element("#scroll_to_top_button_a").click(function () {
        angular.element("html,body").animate({scrollTop: 0}, {
          duration: 500,
          easing: 'swing'
        });
      });

      angular.element(window).scroll(function () {
        if (angular.element(this).scrollTop() > 320) {
          angular.element('#floating_scroll_div').fadeIn();
        } else {
          angular.element('#floating_scroll_div').fadeOut();
        }
      });
    });
  }

  function equalSideDivs() {
    angular.element('#AnnounceDiv').css('height', 'auto');
    angular.element('#rlLb_div').css('height', 'auto');

    var leftSide = angular.element('#leftDiv').outerHeight();
    var rightSide = angular.element('#rightDiv').outerHeight();
    var difference = 0;

    var aBox = angular.element('#AnnounceDiv').outerHeight();
    var rBox = angular.element('#rlLb_div').outerHeight();
    var total;
    if (leftSide < rightSide) {
      difference = rightSide - leftSide;
      total = difference + aBox;
      angular.element('#AnnounceDiv').css('height', total + 'px');
    }

    else {
      difference = leftSide - rightSide;
      total = difference + rBox;
      angular.element('#rlLb_div').css('height', total + 'px');
    }
  }

})();



// WEBPACK FOOTER //
// ./app/vehicledetails/VehicleDetailsController.js